const fileDownloadButtonCompCalendar = {
  title: 'Generar Informe'
};

export default fileDownloadButtonCompCalendar;
